import { useEffect, useState } from "react";
import React from "react";
import moment from 'moment';
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';

export default function StepForm({
    incidencia,
    item,
    tipoId,
    disabled,
    register,
    setValue,
    onChangeStep,
}) {
    const [selectOpt, setSelectOpt] = useState(-1);
    const [viewPresupuesto, setViewPresupuesto] = useState(false);
    let timeout = null;
    const incidenciaSteps = useSelector(state => {
        const { steps } = state;
        return steps.filter(s => s.tipo_incidencia_id === tipoId);
    });

    useEffect(() => {
        if(item) {
            if(item.nombre?.toLowerCase().includes('se envía otra pieza') && item.checked) {
                setViewPresupuesto(true);
            } else setViewPresupuesto(false);
        }
    }, [item]);

    const startTimeOut = (item, e) =>  timeout = setTimeout(() => { 
        timeout = null;
        onChangeStep(item, e.target.value)
    }, 600);
    const clearTimeOut = () => timeout ? clearTimeout(timeout) : null;
    
    return (
        <li key={item.id}>
            <input type="hidden" 
                name={`step.${item.index}.id`}
                {...register(`step.${item.index}.id`)} 
                defaultValue={item.logId} 
            />
            <input type="hidden" 
                name={`step.${item.index}.incidencia_step_id`}
                {...register(`step.${item.index}.incidencia_step_id`)} 
                defaultValue={item.incidencia_step_id} 
            />

            <div className="w-100 d-flex flex-column align-items-center">
                <div className="w-100 d-flex align-items-center justify-content-between">
                    <div className="form-group flex-row d-flex align-items-center mb-0">
                        <input
                            name={`step.${item.index}.checked`}
                            {...register(`step.${item.index}.checked`)} 
                            onChange={(e) => {
                                setValue(`step.${item.index}.checked`, e.target.checked);
                            }}
                            type="checkbox"
                            defaultChecked={item.checked}
                            id={`step.${item.index}.checked`}
                            disabled={disabled}
                        />
                        <label className="ms-2" htmlFor={`step.${item.index}.checked`}>
                            {item.nombre}
                        </label>
                    </div>

                    { (viewPresupuesto && incidencia?.presupuesto_alternativo_id) &&
                        <Link target="_blank" rel="noopener noreferrer" to={"/presupuesto/" + incidencia?.presupuesto_alternativo?.id} title="Ficha presupuesto alternativa" className="text-green fw-bold">
                            {incidencia?.presupuesto_alternativo?.id}
                        </Link>
                    }
                </div>
                <div className="w-100 mt-2">
                    <div className="form-group">
                        <label htmlFor="observaciones">Mensaje predefinido</label>
                        <select 
                            value={selectOpt}
                            disabled={disabled}
                            onChange={(e) => {
                                setSelectOpt(parseInt(e.target.value))
                                setValue(
                                    `step.${item.index}.comentario`, 
                                    incidenciaSteps.find(s => s.id === item.incidencia_step_id)
                                    ?.respuestas[parseInt(e.target.value)]
                                );
                                if(tipoId === 5) onChangeStep(item, incidenciaSteps.find(s => s.id === item.incidencia_step_id)
                                    ?.respuestas[parseInt(e.target.value)])
                            }}>
                            <option key={'opt--1'} value={-1}></option>
                            {incidenciaSteps.find(s => s.id === item.incidencia_step_id)
                                ?.respuestas
                                .map((opt, i) => <option key={'opt-' + i} value={i}>{opt}</option>)}
                        </select>
                    </div>

                    { (item.comentario) &&
                        <div className="chat-info" style={{position: 'unset'}}>
                            <span className="me-3">{moment(item.fecha_comentario).format("DD-MM-YYYY hh:mm:ss")}</span>
                            <span className="text-uppercase">{item.created_by?.username}</span>
                        </div>
                    }
                    <textarea
                        className="w-100"
                        defaultValue={item.comentario}
                        disabled={disabled}
                        name={`step.${item.index}.comentario`}
                        {...register(`step.${item.index}.comentario`)} 
                        onKeyUp={(e) => {
                            e.preventDefault();
                            setValue(`step.${item.index}.comentario`, e.target.value);
                            
                            if(tipoId === 5) {
                                clearTimeOut();
                                startTimeOut(item, e);
                            }
                        }}
                    ></textarea>
                </div>
            </div>
        </li>
    )
}